import React, {useEffect} from 'react';
import {useAuth} from '../context/AuthContext';
import {useNavigate} from 'react-router-dom';
import TopNavbar from "./NavBar/TopNavbar";
import SPLogo from "../assets/SP_Logo.svg";
import UploadAndProcessing from "./UploadAndProcessing";

const Dashboard = () => {
    const {user} = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    if (!user) {
        return (<div className="min-h-screen bg-gray-900 flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>);
    }

    return (<div className="min-h-screen bg-gradient-to-b from-gray-800 via-gray-900 to-black text-white">
            <TopNavbar menuTitle="Audi Campus München"/>

            {/* Main Content */}
            <main className="max-w-6xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                {/* Welcome Section */}
                <div
                    className="relative bg-gradient-to-br from-gray-700 to-gray-800 bg-opacity-90 text-white rounded-lg shadow-2xl p-8">
                    <div
                        className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 opacity-90 rounded-lg"/>
                    <div className="relative z-10 text-center">
                        <h1
                            className="text-4xl font-extrabold text-gray-100 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-blue-500 to-blue-400 animate-shimmer">
                            Willkommen im ACM Tool, <span className="text-gray-200 font-bold">{user.username}</span>!
                        </h1>
                        <div className="mt-4 mx-auto w-1/2 border-t border-gray-600"></div>
                        <p className="mt-6 text-lg text-gray-400 leading-relaxed">
                            Schön, dass Sie hier sind! Nutzen Sie die Werkzeuge unten, um Ihre Daten zu verarbeiten.
                        </p>

                        <style>{`
                @keyframes shimmer {
                    0% {
                        background-position: 0% 50%;
                    }
                    100% {
                        background-position: 100% 50%;
                    }
                }
                .animate-shimmer {
                    background-size: 300% 100%;
                    animation: shimmer 3s linear infinite;
                }
            `}</style>
                    </div>
                </div>

                {/* Upload and Processing Section */}
                <div
                    className="mt-10 relative bg-gradient-to-br from-gray-800 to-gray-900 bg-opacity-90 text-white rounded-lg shadow-2xl p-8">
                    <div
                        className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 opacity-90 rounded-lg"/>
                    <div className="relative z-10">
                        <h2 className="text-2xl font-semibold text-center mb-2">
                            Daten hochladen und analysieren
                        </h2>
                        <p className="text-gray-300 text-center mb-2 text-base">
                            Laden Sie Ihre Excel-Datei hoch und erhalten Sie eine umfassende Analyse als neue Datei.
                        </p>

                        <div className="flex flex-row items-start justify-center space-x-6 mt-auto">
                            <UploadAndProcessing
                                buttonTextUpload="Upload GUSTAFF Stunden"
                                buttonTextProcessing="Klicke hier für die Auswertung"
                                apiUrl="/api/employee/uploadStundenkontingente"
                                exportName="Stundenkontingente.xlsx"
                                onUploadSuccess={() => {
                                }}
                            />
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <div className="flex justify-end">
                    <img src={SPLogo} alt="SP Logo" className="h-5 w-5"/>
                    <p className="text-gray-400 text-sm">Copyright by SolidPulse Software</p>
                </div>
            </footer>
        </div>


    );
};

export default Dashboard;